module.exports = __webpack_public_path__ + "static/media/elixir-packaging.2024fe75.pdf";